import React, { useState, useEffect, createRef } from "react";
import { useSelector, shallowEqual } from "react-redux";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from '@fullcalendar/list';
import interactionPlugin from "@fullcalendar/interaction";
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
import timeGrid from "@fullcalendar/timegrid";
import itLocale from "@fullcalendar/core/locales/it";
import useMobileDetect from "use-mobile-detect-hook";
import moment from "moment-timezone";
import Swal from "sweetalert2";

import * as apiCalendario from "../../api/calendario";
import { ModalVisualizzaEvento } from "./ModalVisualizzaEvento";
import { AddEvento } from "./AddEvento";
import { roles } from "../../config/config";

export default function Calendar({ refreshCounter, passedHeight, passedView }) {
  const detectMobile = useMobileDetect();

  // User redux
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);
  const isAdmin = role === roles.admin || role === roles.gestore || role === roles.developer;
  const isMagazziniere = role === roles.magazziniere;
  const isContabile = role === roles.contabile;

  const [selectedEvent, setSelectedEvent] = useState([]);
  const [show, setShow] = useState(false);
  const [showAdd, setShowAdd] = useState(false);

  const [dateClick, setDateClick] = useState(null);

  const calendarRef = createRef();

  const canAdd = isAdmin || isMagazziniere || isContabile;

  useEffect(() => {
    calendarRef.current.getApi().refetchEvents();
  }, [refreshCounter]);

  function getEvents(info, successCallback, failureCallback) {
    apiCalendario
      .getEventi(user.authToken, moment(info.start).format("YYYY-MM-DD"), moment(info.end).format("YYYY-MM-DD"))
      .then((data) =>
        successCallback(
          data.map((el) => ({
            id: el.id,
            title: el.title,
            location: el.location,
            place: el.place,
            start: moment(el.startDate).toISOString(),
            end: moment(el.endDate).toISOString(),
            start_time: moment(el.start_time).format("HH:mm"),
            end_time: moment(el.end_time).format("HH:mm"),
            allDay: !!el.allDay,
            backgroundColor: el.color,
            color: el.color,
            extendedProps: el,
          }))
        )
      )
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Errore nel caricamento degli eventi",
          confirmButtonColor: "#3699ff",
          confirmButtonText: "Chiudi",
        });
        failureCallback(err);
      });
  }

  return (
    <>
      <ModalVisualizzaEvento show={show} setShow={setShow} selectedEvent={selectedEvent} />
      <AddEvento user={user} show={showAdd} setShow={setShowAdd} selectedEvent={selectedEvent} dateClick={dateClick} />      
        <FullCalendar
        height={passedHeight ?? (
          detectMobile.isDesktop() 
            ? "calc(90vh - 150px)" 
            : "calc(90vh - 200px)"
        )}
        plugins={[momentTimezonePlugin, listPlugin, dayGridPlugin, interactionPlugin, timeGrid]}
        timeZone="Europe/Rome"
        eventClick={({ event }) => {
          setShow(true);
          setSelectedEvent(event);
        }}
        selectable={true}
        dateClick={({ date }) => {
          if (!canAdd) {
            return;
          }
          setSelectedEvent({
            id: null,
            title: "",
            location: "",
            place: "",
            start: date.toISOString(),
            end: date.toISOString(),
            start_time: "00:00",
            end_time: "00:00",
            allDay: true,
            backgroundColor: "",
            color: "",
            extendedProps: {},
          });
          setShowAdd(true);
          setDateClick(date);
        }}
        headerToolbar={
          passedView === "listYear"
          ? {
              start: "title",
              center: "",
              end: "prev,next",
            }
          : detectMobile.isDesktop()
            ? {
                start: "prev,next today",
                center: "title",
                end: "listMonth,dayGridMonth,timeGridWeek",
              }
            : {
                start: "prev,next",
                center: "title",
                end: "listMonth,dayGridMonth,timeGridWeek",
              }
        }
        handleWindowResize={true}
        weekends={true}
        //dayCellDidMount={dateRender}
        nowIndicator={true}
        themeSystem="bootstrap"
        titleFormat={
          passedView === "listYear"
          ? { year: "numeric" }
          : detectMobile.isDesktop()
            ? { year: "numeric", month: "long" }
            : { year: "numeric", month: "short" }
        }
        locales={itLocale}
        locale={"it"}
        events={getEvents}
        initialView={ passedView ?? "dayGridMonth" }
        editable={true}
        ref={calendarRef}
      />
    </>
  );
}
